'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//flow
var APPOINTMENTS = 'appointments';
var MAXIMUM_BAR_WIDTH = 5;
var BAR_CENTER = 2;

var Pagination = function Pagination(props) {
	return _react2.default.createElement(
		'div',
		{ className: _style2.default.pagination },
		_react2.default.createElement(
			'ul',
			null,
			props.selectedPage >= MAXIMUM_BAR_WIDTH && [_react2.default.createElement(
				'li',
				{ key: 'prev' },
				_react2.default.createElement(
					'a',
					{ className: props.searchType !== APPOINTMENTS && _style2.default.treatments, onClick: function onClick() {
							return props.onPageClicked(props.selectedPage - 1);
						} },
					'Prev'
				)
			), _react2.default.createElement(
				'li',
				{ className: _style2.default.ellipseAfter + ' ' + (props.searchType !== APPOINTMENTS && _style2.default.treatments) + ' ', key: '0' },
				_react2.default.createElement(
					'a',
					{ onClick: function onClick() {
							return props.onPageClicked(1);
						} },
					'1'
				)
			)],
			new Array(props.selectedPage >= MAXIMUM_BAR_WIDTH ? props.lastPage - props.selectedPage < MAXIMUM_BAR_WIDTH - 1 && props.lastPage - props.selectedPage + BAR_CENTER + 1 || MAXIMUM_BAR_WIDTH : props.selectedPage + Math.min(props.lastPage - props.selectedPage, BAR_CENTER)).fill(1).map(function (el, index, arr) {
				return _react2.default.createElement(
					'li',
					{ key: index },
					_react2.default.createElement(
						'a',
						{
							className: [props.selectedPage === (props.selectedPage >= MAXIMUM_BAR_WIDTH ? props.selectedPage - BAR_CENTER + index : index + 1) && _style2.default.selected, props.searchType !== APPOINTMENTS && _style2.default.treatments].join(' '),
							onClick: function onClick() {
								return props.onPageClicked(props.selectedPage >= MAXIMUM_BAR_WIDTH ? props.selectedPage - BAR_CENTER + index : index + 1);
							}
						},
						props.selectedPage >= MAXIMUM_BAR_WIDTH ? MAXIMUM_BAR_WIDTH - 1 <= props.lastPage - props.selectedPage && props.selectedPage - BAR_CENTER + index || props.lastPage - arr.length + index + 1 : index + 1
					)
				);
			}),
			props.lastPage - props.selectedPage >= MAXIMUM_BAR_WIDTH - 1 && [_react2.default.createElement(
				'li',
				{
					className: _style2.default.ellipseBefore,
					key: 'prev'
				},
				_react2.default.createElement(
					'a',
					{
						className: props.searchType !== APPOINTMENTS && _style2.default.treatments,
						onClick: function onClick() {
							return props.onPageClicked(props.lastPage);
						}
					},
					props.lastPage
				)
			), _react2.default.createElement(
				'li',
				{ key: '1' },
				_react2.default.createElement(
					'a',
					{
						className: props.searchType !== APPOINTMENTS && _style2.default.treatments,
						onClick: function onClick() {
							return props.onPageClicked(props.selectedPage + 1);
						}
					},
					'Next'
				)
			)]
		)
	);
};

Pagination.propTypes = {
	selectedPage: require('react').PropTypes.any,
	onPageClicked: require('react').PropTypes.func,
	lastPage: require('react').PropTypes.any,
	searchType: require('react').PropTypes.any
};
Pagination.defaultProps = {
	selectedPage: 1,
	onPageClicked: function onPageClicked() {}
};

Pagination.displayName = 'Pagination';
exports.default = Pagination;


// WEBPACK FOOTER //
// ./components/search-results/lib/components/pagination.js